/* eslint-disable no-underscore-dangle */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import Axios from 'axios';
import { fetchSettings } from 'Helpers/utils';
import './i18next';
import Loading from 'Layouts/Main/Loading/Loading';

import Sentry from './sentry';
import App from './App';

import FirebaseProvider from '@/fcm/firebase';

window.__PRODUCTION__ = process.env.NODE_ENV === 'production';
window.__DEVELOPMENT__ = process.env.NODE_ENV !== 'production';

Axios.get('/api/setting').then(res => {
  localStorage.setItem('manadr:settings', res.data);

  if (window.__PRODUCTION__) {
    const globSettings = fetchSettings() || {};
    if (globSettings.SENTRY_DSN_LINK) {
      Sentry.initSentry(globSettings.SENTRY_DSN_LINK);
    }
  }

  ReactDOM.render(
    <FirebaseProvider>
      <Suspense fallback={<Loading />}>
        <App />
      </Suspense>
    </FirebaseProvider>,
    document.getElementById('root'),
  );
});
